import React from "react";
import cns from "classnames";
import { Grid, Paper } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { ThemeType } from "@theme";
import { Subheading as FormSubheading } from "../../typography/FormSubheading";

type Props = React.ComponentProps<typeof Grid> & {
  className?: string;
  fitted?: boolean;
  flat?: boolean;
  fullWidth?: boolean;
  PaperProps?: Partial<React.ComponentProps<typeof Paper>>;
  title?: string;
  withBorder?: boolean;
};

/**
 * Display left label and the field together inside grid items
 */
export function FormSection(props: Props) {
  const {
    children,
    className,
    fitted,
    flat,
    fullWidth,
    PaperProps: PaperPropsProp,
    title,
    withBorder,
    ...rest
  } = props;

  const classes = useStyles({});

  const rootClassName = cns(classes.root, className, {
    [classes.responsive]: !fullWidth
  });

  const content = (
    <>
      {title && <FormSubheading className={classes.title}>{title}</FormSubheading>}
      {children}
    </>
  );

  const { className: propsClassName, ...restPaperProps } = PaperPropsProp || {};

  return (
    <Grid component={"section" as any} item className={rootClassName} {...rest}>
      {fitted && content}
      {!fitted && (
        <Paper
          className={cns(classes.section, propsClassName, {
            [classes.withBorder]: withBorder
          })}
          elevation={flat ? 0 : 1}
          {...restPaperProps}
        >
          {content}
        </Paper>
      )}
    </Grid>
  );
}

const useStyles = makeStyles((theme: ThemeType) => ({
  root: {
    width: "100%"
  },

  responsive: {
    [theme.breakpoints.up("md")]: {
      width: "50%"
    },

    [theme.breakpoints.up("xl")]: {
      width: "50%"
    }
  },

  section: {
    padding: theme.spacing(2)
  },

  withBorder: {
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: theme.palette.grey[200]
  },

  title: {
    marginBottom: theme.spacing()
  }
}));

export default FormSection;
